<template>
  <div id="app" data-server-rendered="true">
    <!-- 1.头部导航 -->
    <yp-navbar ref="navbar" class="no-transparent-navbar" mobileTitle="企业文化"></yp-navbar>
    <!-- 2.背景图 + 标题 -->
    <page-title-bg first-font="a" title-en="BOUT US" title-zh="走进悦朋"></page-title-bg>
    <!-- 3.面包屑导航 -->
    <div class="bread-crumbs-container hidden-xs">
      <div class="container">
        <ol class="breadcrumb">
          <li><a href="/index.html">首页</a></li>
          <li><a href="/companyProfile.html">走进悦朋</a></li>
          <li class="active">企业文化</li>
        </ol>
      </div>
    </div>
    <!-- 4.经营理念 -->
    <section class="business-philosophy-container">
      <div class="container">
        <div class="sec-title-container">
          <div class="sec-title-zh">经营理念</div>
          <div class="sec-title-en">BUSINESS PHILOSOPHY</div>
        </div>
        <div class="business-philosophy-content">
          <div class="img-font-box" v-for="(item, index) in businessList" :key="index">
            <div class="img-box" :style="{ backgroundImage: `url(${item.src})` }">
              <img v-lazy="item.src" alt="" draggable="false" />
            </div>
            <div class="font-box">
              <div class="font-zh">
                <div class="font-large">{{ item.fontZh.large }}</div>
                <div class="font-small">{{ item.fontZh.small }}</div>
              </div>
              <div class="font-border"></div>
              <div class="font-en">{{ item.fontEn }}</div>
            </div>
          </div>
        </div>
      </div>
    </section>
    <!-- 5.企业愿景 -->
    <section class="corporate-vision-container">
      <div class="corporate-vision-container--inner">
        <div class="sec-title-container">
          <div class="sec-title-zh">企业愿景</div>
          <div class="sec-title-en">CORPORATE VISION</div>
        </div>
        <div class="corporate-vision-content" v-lazy:background-image="'/static/img/product.png'">
          <div class="container">
            <div class="font-zh">做有幸福感的科技企业</div>
            <div class="font-en">Be a technology enterprise with happiness</div>
          </div>
        </div>
      </div>
      <!-- <div class="container">
        <div class="sec-title-container">
          <div class="sec-title-zh">企业愿景</div>
          <div class="sec-title-en">CORPORATE VISION</div>
        </div>
      </div> -->
    </section>
    <!-- 6.企业使命 -->
    <section class="enterprise-mission-container">
      <div class="container">
        <div class="sec-title-container">
          <div class="sec-title-zh">企业使命</div>
          <div class="sec-title-en">ENTERPRISE MISSION</div>
        </div>
        <div class="enterprise-mission-content">
          <div class="list-item-box" v-for="(item, index) in enterpriseList" :key="index">
            <div class="font-title">{{ item.title }}</div>
            <div class="font-desc">{{ item.desc }}</div>
          </div>
        </div>
      </div>
    </section>
    <!-- 7.市场定位 -->
    <section class="market-positioning-container">
      <div class="container">
        <div class="sec-title-container">
          <div class="sec-title-zh">市场定位</div>
          <div class="sec-title-en">MARKET POSITIONING</div>
        </div>
        <div class="market-positioning-content">
          <div class="font-box">
            <div class="font-en">MARKET POSITIONING</div>
            <div class="font-zh">做零售行业智慧创新</div>
            <div class="font-zh">创科技企业社会价值</div>
          </div>
          <div class="imgs-container">
            <div class="img-content">
              <div class="img-box" v-lazy:background-image="'/static/images/bud.png'">
                <img v-lazy="'/static/images/bud.png'" alt="" />
              </div>
            </div>
            <div class="img-content">
              <div class="img-box" v-lazy:background-image="'/static/images/bird.png'">
                <img v-lazy="'/static/images/bird.png'" alt="" />
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
    <!-- 7.footer -->
    <yp-footer></yp-footer>
  </div>
</template>
<script>
import YpNavbar from '@/components/navbar.vue'
import PageTitleBg from '@/components/page-title-bg.vue'
import YpFooter from '@/components/footer.vue'
export default {
  components: {
    YpNavbar,
    PageTitleBg,
    YpFooter,
  },
  data() {
    return {
      businessList: [
        {
          src: '/static/images/about-business-service.png',
          fontZh: {
            large: '服务',
            small: '为本',
          },
          fontEn: 'SERVIC-ORENTEDI',
        },
        {
          src: '/static/images/about-business-promote.png',
          fontZh: {
            large: '推动',
            small: '创新',
          },
          fontEn: 'PROMOTE INNOVATION',
        },
        {
          src: '/static/images/about-business-win.png',
          fontZh: {
            large: '协作',
            small: '共赢',
          },
          fontEn: 'WIN-WIN COOPERATION',
        },
      ],
      enterpriseList: [
        { title: '平台', desc: '为员工创造平台' },
        { title: '价值', desc: '为客户创造价值' },
        { title: '模式', desc: '为行业创造模式' },
        { title: '财富', desc: '为社会创造财富' },
      ],
    }
  },
  created() {
    Media($(window).width())
    function Media(width) {
      if (width > 750) {
        refreshRem(1920)
      } else {
        refreshRem(750)
      }
    }
    // 根据设计图尺寸计算rem
    function refreshRem(designSize) {
      let html = document.documentElement
      let wW = html.clientWidth // 窗口宽度
      let rem = (wW * 100) / designSize
      document.documentElement.style.fontSize = rem + 'px'
    }
  },
}
</script>
<style lang="scss">
#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
}

#nav {
  padding: 30px;

  a {
    font-weight: bold;
    color: #2c3e50;

    &.router-link-exact-active {
      color: #42b983;
    }
  }
}
</style>
